import { FC } from 'react';
import { StripeSinglePaymentMethod } from './StripeSinglePaymentMethod';
import { StripeMultiplePaymentMethod } from './StripeMultiplePaymentMethod';
import { usePaymentMethodSelectContext } from '../PaymentMethodSelectContext';
import { isStripeElementPaymentMethod } from '../../types';

export const StripePaymentMethod: FC = () => {
    const { paymentMethods } = usePaymentMethodSelectContext();

    const stripePaymentMethods = paymentMethods.filter(isStripeElementPaymentMethod);

    if (stripePaymentMethods.length === 1) {
        return <StripeSinglePaymentMethod paymentMethod={stripePaymentMethods[0]} />;
    }

    return <StripeMultiplePaymentMethod />;
};
